import { Box, Rating, Checkbox, Button, makeStyles, Grid2, Chip, Typography, FormGroup, FormControl, FormControlLabel, Snackbar, Alert } from "@mui/material";
import PaymentIcon from '@mui/icons-material/Payment';

import VisibilityIcon from '@mui/icons-material/Visibility';
import { useStyles } from "../../screens/ProductList/ProductList";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { removeProductsToCompare, selectProductsToCompare } from '../../redux/actions';
import { RootState } from "../../redux/reducers";

const HEIGHT = window.innerHeight
const WIDTH = window.innerWidth
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

type Props = {
    product: any,
    showCompareBtn: boolean
};

export const ProductGridView: React.FC<Props> = ({ product, showCompareBtn }) => {
    const styles = useStyles();
    const history = useNavigate();
    const [saleLabel, setSaleLabel] = useState<string>("");
    const selectedProductIds = useSelector((state: RootState) => state.productComparison);
    const [checkedProductIds, setCheckedProductIds] = useState([]);
    const [state, setState] = useState<boolean>(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (product.productDiscount && product.productDiscount.discountType == 'PERCENTAGE') {
            setSaleLabel(product.productDiscount.discountValue + "% OFF")
        }
        if (product.productDiscount && product.productDiscount.discountType == 'FIXED_AMOUNT') {
            setSaleLabel("$" + product.productDiscount.discountValue + " OFF")
        }
    })

    const handleView = (e: any, item: any) => {

        console.log(item)
        history("/productdetail", { state: item.id });
    }

    const handleCheckboxChange = useCallback((e, product) => {
        if (selectedProductIds.productIdsToCompare.length >= 4 && e.target.checked) {
            setState(true);
            return;
        }
        else {

            if (e.target.checked) {
                // const newCheckedProducts = [product];
                if (!selectedProductIds.productIdsToCompare.some(p => p.productId === product.productId)) {
                    dispatch(selectProductsToCompare([...selectedProductIds.productIdsToCompare, product]));
                }

            } else {
                // const productIdToRemove = [product.productId];
                dispatch(removeProductsToCompare(product.productId));
            }
        }
    }, [dispatch, selectedProductIds]);



    const handleClose = () => {
        setState(false);
    };

    return (
        <>
            <Box
                sx={{
                    boxShadow: 2,
                }}
                className={styles.BestBox}>
                <Box onClick={() => history("/productdetail", { state: product.productId })}>
                    <Box style={{ width: '100%', alignItems: "center", flexDirection: "row", justifyContent: "flex-end", display: 'flex' }}>
                        <Box sx={{ height: 30, overflow: 'hidden' }}>
                            {product?.productDiscount && <Chip
                                label={saleLabel}
                                color="success"
                                size="small"
                                variant="filled"
                                style={{
                                    marginBottom: "10px",
                                    color: "white",
                                    fontWeight: "bold"
                                }} />}
                        </Box>
                    </Box>
                    <Box
                        style={{ height: HEIGHT / 100 * 18, alignItems: "center", justifyContent: "center", marginTop: HEIGHT / 100 * 1, marginBottom: HEIGHT / 100 * 1, width: '100%' }}>
                        <Box
                            component="img"
                            style={{ width: '80%', height: HEIGHT * 18 / 100, objectFit: 'contain' }}
                            src={product?.productImageUrl ? product.productImageUrl : require('../../../assets/Home/Cctv.png')} />
                    </Box>
                    <label className={styles.bestText1}>{product.category.categoryName}</label>
                    <Box style={{}}>
                        <label className={styles.bestText}>{product.displayName ? product.displayName : "2 MP Build-in Mic Fixed Bullet Network Camera"}</label>
                    </Box>
                    <Box>
                        <Box style={{ marginTop: HEIGHT * 2 / 100 }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={7} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    {product.salePrice ? <label className={styles.orgText}>${product.salePrice}</label> : <label className={styles.orgText}>$0</label>}
                                    {product.mrpPrice ? <label className={product.productDiscount ? styles.crsText : styles.crsTextNormal}>${product.mrpPrice}</label> : <label className={styles.crsText}>$0</label>}
                                </Grid2>
                                <Grid2 size={5} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <Box sx={{ '& .MuiRating-icon': { fontSize: 12 } }}>
                                        <Rating value={product.averageRating ? product.averageRating : 0} readOnly precision={0.5} size={'small'} />
                                    </Box>
                                    <Box style={{ flexDirection: "row", alignItems: "center", marginLeft: '2px', marginBottom: '5px' }}>
                                        <label className={styles.starCount}>({product.totalRatings})</label>
                                    </Box>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </Box>
                </Box>

                <Box
                    style={{
                        marginTop: (HEIGHT / 100) * 1,
                    }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2 size={5} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            {showCompareBtn && <FormGroup>
                                <FormControlLabel control={<Checkbox name="antoine" {...label} sx={{ p: 0, mr: 0.5 }} size="small"
                                    onChange={(e) => handleCheckboxChange(e, product)} />} label="Compare" checked={selectedProductIds.productIdsToCompare.some((p: any) => p.productId === product.productId)} />
                            </FormGroup>}
                        </Grid2>
                        <Grid2 size={7} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Button
                                variant='outlined'
                                color="success"
                                size="small"
                                sx={{
                                    paddingLeft: '19px',
                                    minWidth: '10px',
                                    visibility: 'hidden'
                                }}
                                aria-label='Buy Now'
                                startIcon={<PaymentIcon />}>
                            </Button>
                            <Button
                                variant='outlined'
                                color="warning"
                                size="small"
                                sx={{
                                    paddingLeft: '19px',
                                    minWidth: '13px',
                                    cursor: 'pointer'
                                }}
                                style={{ marginRight: '0px', marginLeft: '10px' }}
                                onClick={(e) => {
                                    handleView(e, product);
                                }}
                                startIcon={<VisibilityIcon style={{ color: '#c72a22' }} />}>
                            </Button>
                        </Grid2>
                    </Grid2>
                </Box>
                <Box sx={{ width: 500 }}>
                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        open={state}
                        onClose={handleClose}
                        autoHideDuration={3000}
                    >
                        <Alert
                            onClose={handleClose}
                            severity="error"
                            variant="filled"
                            sx={{
                                width: '100%',
                                backgroundColor: '#c72a22',
                                color: '#fff',
                            }}
                        >
                            You can compare maximum 4 items at a time
                        </Alert>
                    </Snackbar>
                </Box>
            </Box>
        </>
    );
};